import { render, staticRenderFns } from "./xjffCheckedItem.vue?vue&type=template&id=47a405f0&scoped=true"
import script from "./xjffCheckedItem.vue?vue&type=script&lang=js"
export * from "./xjffCheckedItem.vue?vue&type=script&lang=js"
import style0 from "./xjffCheckedItem.vue?vue&type=style&index=0&id=47a405f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a405f0",
  null
  
)

export default component.exports